// import { useHistory } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import './Notfound.css';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

const Notfound = () => {
    // let history = useHistory();
    let sizes, scene, group, obj, camera, light, renderer;

    const canvasRef = useRef(null);

    useEffect(() => {
        Init();
        return () => {

        }
    }, []);
    const loadingManager = new THREE.LoadingManager();

    const Init = () => {
        sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        }
        scene = new THREE.Scene();
        group = new THREE.Group();
        scene.add(group);
        ///
        SetBackground();
        SetCamera();
        SetLight();
        SetModel();
        SetRenderer();

        Animate();


        window.addEventListener('resize', ResizeScreen);
    }
    const SetBackground = () => {
        scene.fog = new THREE.Fog(0xE1E9F6, 8, 15);
    }

    const SetCamera = () => {
        camera = new THREE.PerspectiveCamera(
            20, // fov
            sizes.width / sizes.height, //size
            0.1,
            1000
        );
        // console.log(camera.target);
        scene.add(camera);
        camera.position.set(0, 6, 8.45);
        camera.lookAt(0, -0.25, -2);
    }
    const SetLight = () => {
        light = new THREE.DirectionalLight(0xffffff, 1);
        light.position.set(2, 5, 3);
        light.castShadow = true;
        scene.add(light);

        const am = new THREE.AmbientLight(0x0055aa);
        scene.add(am);
    }

    const SetModel = () => {
        const gltfLoader = new GLTFLoader(loadingManager);
        const url = './data/model/World.glb';
        gltfLoader.load(
            url,
            (gltf) => {
                const model = gltf.scene;
                model.name = 'GLTF Model'

                model.scale.set(5, 5, 5);
                model.position.set(0, 0, 0);
                model.rotation.set(0, -Math.PI / 4, 0);

                model.traverse(child => {
                    if (child.isMesh) {
                        // child.castShadow = true;
                        // child.receiveShadow = true;
                    }
                    if (child.name.includes('stage')) {
                        child.visible = false;
                    }
                    if (child.name.includes('land')) {
                        child.visible = false
                    }
                    if (child.name == 'cones')
                        child.visible = false;

                });
                group.add(model);
                obj = model;
                console.log(dumpObject(scene).join('\n'));
            },
            (xhr) => {
                const loadedLate = (xhr.loaded / 41374508
                ) * 100;

                if (loadedLate >= 100) {
                    //* loading manager onload 로 이동.
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    const SetRenderer = () => {
        renderer = new THREE.WebGLRenderer({
            canvas: canvasRef.current,
            alpha: true,
            antialias: true
        });
        renderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        renderer.setClearColor(0xffffff, 0);

        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.VSMShadowMap;
        renderer.toneMapping = THREE.ACESFilmicToneMapping;
        renderer.toneMappingExposure = 1.0;
        // renderer.outputEncoding = THREE.sRGBEncoding;
    }
    const Render = () => {
        renderer.render(scene, camera);
    }

    const Animate = () => {
        requestAnimationFrame(Animate);
        Render();
    }
    const ResizeScreen = () => {
        console.log("resize")
        sizes.width = window.innerWidth;
        sizes.height = window.innerHeight;

        camera.aspect = sizes.width / sizes.height;
        camera.updateProjectionMatrix();

        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        renderer.setSize(sizes.width, sizes.height);
    }

    const dumpObject = (obj, lines = [], isLast = true, prefix = '') => {
        const localPrefix = isLast ? '└─' : '├─';
        lines.push(`${prefix}${prefix ? localPrefix : ''}${obj.name || '*no-name*'} [${obj.type}]`);
        const newPrefix = prefix + (isLast ? '  ' : '│ ');
        const lastNdx = obj.children.length - 1;
        obj.children.forEach((child, ndx) => {
            const isLast = ndx === lastNdx;
            dumpObject(child, lines, isLast, newPrefix);
        });
        return lines;
    }

    return (
        <div className="notfound">
            <canvas
                ref={canvasRef}
                className='notfound-webgl'></canvas>
            <div className="notfound-container">
                <div className="notfound_code">
                    <h1>404</h1>
                </div>
                <div className="notfound_desc">
                    The address you entered does not exist, or the requested page
                    <br></br>
                    has been moved or deleted. Return to the homepage.</div>
                <a href='/' className="notfound_btn">Go back Home
                    <img src={process.env.PUBLIC_URL + "/data/img/ic/arrow.png"} alt="arrow" /></a>
            </div >
        </div>
    )
}
export default Notfound